import { Outlet } from "react-router-dom";
import 'react-tooltip/dist/react-tooltip.css'
function App() {
  return (
    <Outlet />
  );
}

export default App;
